import axios from "axios";
import ApiURLs from "@/ApiURLs";
import { UrlBuilder } from "@/builders/UrlBuilder";

export class WaitlistService {
  getAllSchoolPlans() {
    return axios.get(ApiURLs.getSchoolPlansInfo);
  }

  getSchoolPlanById(id: number) {
    return axios.get(`${ApiURLs.getSchoolPlansInfo}/${id}`);
  }

  getDailyPayment() {
    return axios.get(ApiURLs.getDailyPay).then(response => response.data);
  }

  getHourlyPayment() {
    return axios.get(ApiURLs.getHourlyPay);
  }

  getCurrentProvider(childId: string, childcareProviderId: string) {
    const url = UrlBuilder.build(ApiURLs.getWaitlistProviderById, { childId: childId, childcareProviderId: childcareProviderId })

    return axios.get(url);
  }

  getFilteredProviders(id: string) {
    return this.sendRequestWithRetry(`${ApiURLs.getFilteredProviders}/${id}/waitlist/providers`, 3, 1000)
  }

  public static async getWaitlistFilters(waitlistData: any) {
    const response = await axios.post(ApiURLs.getWaitlistFilters, waitlistData);
    return response.data;
  }

  async sendRequestWithRetry(url: string, retries = 3, delay = 1000) {
    for (let attempt = 1; attempt <= retries; attempt++) {
      try {
        const response = await axios(url);
        
        if (response.status >= 200 && response.status < 300) {
          return response;
        } else {
          throw new Error(`Request failed with status ${response.status}`);
        }
  
      } catch (error) {
        if (attempt < retries) {
          await new Promise(resolve => setTimeout(resolve, delay));
        } else {
          throw error; 
        }
      }
    }
  }

  getChildcareTypes() {
    return axios.get(ApiURLs.getChildcareTypes);
  }

  getProviderTypes(waitingListTicketId: number) {
    const requestUrl = waitingListTicketId
      ? `${ApiURLs.getProviderTypes}?waitingListTicketId=${waitingListTicketId}`
      : ApiURLs.getProviderTypes;

      return axios.get(requestUrl);
  }

  postWaitlistData(id: string, waitlistData: any) {
    return axios.post(`${ApiURLs.childUrl}/${id}/waitlist`, waitlistData);
  }

  putWaitlistData(childId: string, waitlistTicketId: number, updatedWaitlistData: any) {
    return axios.put(`${ApiURLs.childUrl}/${childId}/waitlist/${waitlistTicketId}`,updatedWaitlistData);
  }

  getWaitlistPriorities(userId: string) {
    return axios.get(`${ApiURLs.providersUrl}/${userId}/waitlist-priorities`);
  }

  postWaitlistPriorities(providerId: string, waitlistTicketId: number, priorities: number[]) {
    return axios.post(`${ApiURLs.providersUrl}/${providerId}/waitlist/${waitlistTicketId}`, {priorities});
  }

  getWaitlistRequests(userId: string) {
    return axios.get(`${ApiURLs.parentsUrl}/${userId}/waitlist/requests`)
  }
  deleteWaitlistRequest(providerId: string, waitlistTicketId: number, body: any) {
    return axios.patch(`${ApiURLs.providersUrl}/${providerId}/waitlist/${waitlistTicketId}`, body);
  }
}
